import { RegisterClientFormView } from "./view";

export const RegisterClientForm = () => {
	return <RegisterClientFormView />;
};
